<script setup lang="ts">
import { cloneDeep } from "lodash"
import { PromoSpecialProps } from "./PromoSpecial.props"
import { ThemeProps, getBannerThemeBg } from "~/utils/banner"

const props = defineProps<PromoSpecialProps>()
const emit = defineEmits<{ (e: "onButtonClick"): void }>()

const { title, promoId, promoLocation } = toRefs(props)

const _theme = computed(() => {
  // TODO: change these uppercased names to the ones from "ThemeProps"
  const nameMap = {
    Blue: ThemeProps.BLUE,
    Pink: ThemeProps.PINK,
    Red: ThemeProps.RED,
    Black: ThemeProps.BLACK,
    ["Black-Friday"]: ThemeProps.BLACK_FRIDAY
  }

  const newTheme = props.theme && nameMap[props.theme]
  return getBannerThemeBg(newTheme)
})

const _mainImage = computed(() => {
  let newMainImage = props.mainImage ? cloneDeep(props.mainImage) : undefined
  if (newMainImage) {
    newMainImage = setAdditionalImageProps(newMainImage, {
      deleteWidthFullFromStyle: true
    })

    newMainImage.imgAttrs = setAdditionalImageAttrs(newMainImage.imgAttrs, {
      class: "md:w-full"
    })
  }

  return newMainImage
})
</script>

<template>
  <GAViewPromotion
    :promoId="promoId ?? ''"
    :title="title ?? ''"
    :promoLocation="promoLocation ?? ''"
  >
    <section class="grid-standard py-6 md:py-16" :class="_theme">
      <div
        v-if="mainImage"
        class="
          col-span-full
          mb-10
          flex
          items-center
          justify-center
          md:order-1
          md:col-span-6
          md:mb-0
        "
      >
        <UtilsWrapperImage v-bind="mainImage" />
      </div>
      <div class="col-span-full md:col-span-6">
        <p
          v-if="title"
          class="
            elephant-bold
            md:whale-bold
            lg:dyno-bold
            text-white
            mb-2
            uppercase
          "
        >
          {{ title }}
        </p>
        <UtilsMarkdown
          class="
            beaver
            md:pig-medium
            markdown__strong-positive-100
            text-white
            flex flex-col
            gap-2
          "
          :content="description"
        />

        <GASelectPromotion
          :promoId="promoId ?? ''"
          :title="title ?? ''"
          :promoLocation="promoLocation ?? ''"
        >
          <UtilsButton
            v-if="cta"
            v-bind="cta"
            class="
              beaver-medium
              mt-6
              inline-block
              text-center
              md:mt-7
              md:w-64
              lg:mt-4
              [&>*]:whitespace-normal
            "
            @click="emit('onButtonClick')"
            fluid
            :class="{ 'custom-btn-bg-white': theme === 'Pink' }"
          />
        </GASelectPromotion>
      </div>
    </section>
  </GAViewPromotion>
</template>
